import { render, staticRenderFns } from "./TaskRequestTableControls.vue?vue&type=template&id=8796d724&scoped=true"
import script from "./TaskRequestTableControls.vue?vue&type=script&lang=js"
export * from "./TaskRequestTableControls.vue?vue&type=script&lang=js"
import style0 from "./TaskRequestTableControls.vue?vue&type=style&index=0&id=8796d724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8796d724",
  null
  
)

export default component.exports